import {
	Button,
	Table,
	TableColumn,
	Input,
	Icon,
	Form,
	FormItem,
	Switch,
	Radio,
	RadioGroup,
	RadioButton,
	Checkbox,
	CheckboxGroup,
	Select,
	Option,
	DatePicker,
	TimeSelect,
	TimePicker,
	Upload,
	Col,
	Pagination,
	MessageBox,
	Message,
	Tooltip,
	Popover,
	Dialog,
	Transfer
} from 'element-ui'
const install = function(Vue) {
	if(install.installed) return
	Vue.component(Transfer.name, Transfer)
	Vue.component(Dialog.name, Dialog)
	Vue.component(Button.name, Button)
	Vue.component(Table.name, Table)
	Vue.component(Input.name, Input)
	Vue.component(Icon.name, Icon)
	Vue.component(Form.name, Form)
	Vue.component(Select.name, Select)
	Vue.component(TableColumn.name, TableColumn)
	Vue.component(Option.name, Option)
	Vue.component(FormItem.name, FormItem)
	Vue.component(Switch.name, Switch)
	Vue.component(Radio.name, Radio)
	Vue.component(RadioGroup.name, RadioGroup)
	Vue.component(RadioButton.name, RadioButton)
	Vue.component(Checkbox.name, Checkbox)
	Vue.component(CheckboxGroup.name, CheckboxGroup)
	Vue.component(TimeSelect.name, TimeSelect)
	Vue.component(TimePicker.name, TimePicker)
	Vue.component(DatePicker.name, DatePicker)
	Vue.component(Upload.name, Upload)
	Vue.component(Col.name, Col)
	Vue.component(Pagination.name, Pagination)
	Vue.component(Tooltip.name, Tooltip)
	Vue.component(Popover.name, Popover)
	Vue.component(Transfer.name, Transfer)
	Vue.prototype.$msgbox = MessageBox
	Vue.prototype.$alert = MessageBox.alert
	Vue.prototype.$confirm = MessageBox.confirm
	Vue.prototype.$prompt = MessageBox.prompt
	Vue.prototype.$message = Message
	Vue.prototype.$success = (msg)=>Message({
          message: msg,
          type: 'success'
        })
	Vue.prototype.$warning = (msg)=>Message({
          message: msg,
          type: 'warning'
        })
	Vue.prototype.$errorMsg = (msg)=>Message({
          message: msg,
          type: 'error'
        })
}

export default {
	install
}


// WEBPACK FOOTER //
// ./src/components/ele/index.js